import { FIELDS } from "../../../../constants/PostFormFields";

type StoryTagPost = {
  isStory?: boolean;
  storyType?: string;
};

/**
 * SKE-4539. The tag fields Instagram actually honours for this post.
 *
 * Meta accepts user tags on a story and nothing else, so a location,
 * collaborator or product tag set there is dropped at publish with nothing to
 * tell the customer. A reel or IGTV story routes to the phone notification
 * path, which cannot carry a tag at all, so it gets none of them.
 *
 * A non-story post keeps whatever the platform config made visible.
 */
export const storyTagFields = (
  post: StoryTagPost | null | undefined,
  visibleFields: string[]
): string[] => {
  if (!post?.isStory) return visibleFields;
  if (post.storyType === "reel" || post.storyType === "igtv") return [];
  return (visibleFields ?? []).filter((field) => field === FIELDS.USER_TAGS);
};
